module.exports = __webpack_public_path__ + "img/16.9b21599d.png";